// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/core/v1/node.proto (package thru.core.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { Pubkey } from "../../common/v1/primitives_pb";
import { file_thru_common_v1_primitives } from "../../common/v1/primitives_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/core/v1/node.proto.
 */
export const file_thru_core_v1_node: GenFile = /*@__PURE__*/
  fileDesc("Chd0aHJ1L2NvcmUvdjEvbm9kZS5wcm90bxIMdGhydS5jb3JlLnYxIjcKC05vZGVDb250YWN0EhUKCGlwNF9hZGRyGAEgASgNQgPgQQISEQoEcG9ydBgCIAEoDUID4EECIkIKDE5vZGVQcm90b2NvbBIYCgtjb250YWN0X2lkeBgBIAEoDUID4EECEhgKC3Byb3RvY29sX2lkGAIgASgNQgPgQQIijgIKCk5vZGVSZWNvcmQSFAoHdmVyc2lvbhgBIAEoDUID4EECEhUKCGNoYWluX2lkGAIgASgNQgPgQQISEwoGc2VxbnVtGAMgASgEQgPgQQISKwoGcHVia2V5GAQgASgLMhYudGhydS5jb21tb24udjEuUHVia2V5QgPgQQISMAoIY29udGFjdHMYBSADKAsyGS50aHJ1LmNvcmUudjEuTm9kZUNvbnRhY3RCA+BBARIyCglwcm90b2NvbHMYBiADKAsyGi50aHJ1LmNvcmUudjEuTm9kZVByb3RvY29sQgPgQQESFgoJc2lnbmF0dXJlGAcgASgMQgPgQQISEwoGaXNfb3duGAggASgIQgPgQQJCuAEKEGNvbS50aHJ1LmNvcmUudjFCCU5vZGVQcm90b1ABWkBnaXRodWIuY29tL1VudG8tTGFicy90aHJ1LW5ldC9ncnBjL3BrZy9wcm90by90aHJ1L2NvcmUvdjE7Y29yZXYxogIDVENYqgIMVGhydS5Db3JlLlYxugIEVEhVQ8oCDFRocnVcQ29yZVxWMeICGFRocnVcQ29yZVxWMVxHUEJNZXRhZGF0YeoCDlRocnU6OkNvcmU6OlYxYgZwcm90bzM", [file_google_api_field_behavior, file_thru_common_v1_primitives]);

/**
 * NodeContact represents a network contact address for a node.
 *
 * @generated from message thru.core.v1.NodeContact
 */
export type NodeContact = Message<"thru.core.v1.NodeContact"> & {
  /**
   * IPv4 address as 32-bit integer (network byte order).
   *
   * @generated from field: uint32 ip4_addr = 1;
   */
  ip4Addr: number;

  /**
   * Port number.
   *
   * @generated from field: uint32 port = 2;
   */
  port: number;
};

/**
 * Describes the message thru.core.v1.NodeContact.
 * Use `create(NodeContactSchema)` to create a new message.
 */
export const NodeContactSchema: GenMessage<NodeContact> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_node, 0);

/**
 * NodeProtocol represents a protocol supported by a node contact.
 *
 * @generated from message thru.core.v1.NodeProtocol
 */
export type NodeProtocol = Message<"thru.core.v1.NodeProtocol"> & {
  /**
   * Index into the contacts array.
   *
   * @generated from field: uint32 contact_idx = 1;
   */
  contactIdx: number;

  /**
   * Protocol identifier (discovery=1, block_dissem=2, consensus=3, snapshot=4, repair=5, transaction=6).
   *
   * @generated from field: uint32 protocol_id = 2;
   */
  protocolId: number;
};

/**
 * Describes the message thru.core.v1.NodeProtocol.
 * Use `create(NodeProtocolSchema)` to create a new message.
 */
export const NodeProtocolSchema: GenMessage<NodeProtocol> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_node, 1);

/**
 * NodeRecord represents a node's signed identity and network information.
 *
 * @generated from message thru.core.v1.NodeRecord
 */
export type NodeRecord = Message<"thru.core.v1.NodeRecord"> & {
  /**
   * Record version.
   *
   * @generated from field: uint32 version = 1;
   */
  version: number;

  /**
   * Chain identifier.
   *
   * @generated from field: uint32 chain_id = 2;
   */
  chainId: number;

  /**
   * Sequence number (incremented on each record update).
   *
   * @generated from field: uint64 seqnum = 3;
   */
  seqnum: bigint;

  /**
   * Node's ED25519 public key.
   *
   * @generated from field: thru.common.v1.Pubkey pubkey = 4;
   */
  pubkey?: Pubkey | undefined;

  /**
   * Network contact addresses.
   *
   * @generated from field: repeated thru.core.v1.NodeContact contacts = 5;
   */
  contacts: NodeContact[];

  /**
   * Protocols supported at each contact.
   *
   * @generated from field: repeated thru.core.v1.NodeProtocol protocols = 6;
   */
  protocols: NodeProtocol[];

  /**
   * ED25519 signature over the record.
   *
   * @generated from field: bytes signature = 7;
   */
  signature: Uint8Array;

  /**
   * True if this is the responding node's own record.
   *
   * @generated from field: bool is_own = 8;
   */
  isOwn: boolean;
};

/**
 * Describes the message thru.core.v1.NodeRecord.
 * Use `create(NodeRecordSchema)` to create a new message.
 */
export const NodeRecordSchema: GenMessage<NodeRecord> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_node, 2);

